<template>
	<div>
		<div
			style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
			v-if="LoaderStatus"
		>
			<Spinner />
		</div>
		<div class="archivetest-main-container">
			<div class="d-flex align-items-center justify-content-between mt-3">
				<div class="d-flex align-items-center">
					<div class="pointer">
						<img
							src="../../assets/icons/Reports/bckarrow.svg"
							alt=""
							@click="goTobackpage()"
						/>
					</div>
					<div class="heading-container boxtext ml-3">
						<span>Inactive Tests</span>
					</div>
				</div>
				<div class="d-flex">
					<div
						@click="showSortCard = !showSortCard"
						class="sort-box mr-2 pl-3 pr-3 relativeclass switchtext pointer"
						ref="sort"
						v-closable="{
							exclude: ['sort', 'sortdropdown'],
							handler: 'hidesortoptions',
						}"
					>
						<div>
							Sort
							<span class="ml-3">
								<img src="../../assets/sorticon.svg" alt=""
							/></span>
						</div>
					</div>
					<div
						v-if="showSortCard"
						ref="sortdropdown"
						class="relativeclass topicdashboard"
					>
						<div class="tnt-sortcard p-0">
							<div
								@click="showSortCard = !showSortCard"
								class="xMarkCancel pointer z-10"
							>
								<img src="../../assets/xmark.svg" alt="" />
							</div>
							<b-form-group class="sec-mcq-datacard">
								<b-form-radio
									class="sort-radio"
									v-for="(sort, index) in sort_options"
									:key="index"
									v-model="sort_selected"
									@change="applySort()"
									:value="{
										column: sort.type,
										order: sort.order,
									}"
								>
									{{ sort.text }}
								</b-form-radio>
							</b-form-group>
						</div>
					</div>

					<div
						ref="filter"
						v-closable="{
							exclude: ['filter'],
							handler: 'hidefilteroptions',
						}"
					>
						<div class="filter-box pr-3 switchtext relativeclass pointer">
							<div class="ml-3 d-flex" @click="openFilter">
								Filter
								<div class="ml-2 d-flex relativeclass">
									<span><img src="../../assets/filtericon.svg" alt="" /> </span>
									<div class="archivetest-filter-count" v-if="filtercount != 0">
										{{ filtercount }}
									</div>
								</div>
							</div>
							<div
								v-if="showfiltercard"
								ref="filterdropdown"
								class="relativeclass"
							>
								<div
									class="tnt-filtercard-test"
									style="top: 10px; right: -16px"
								>
									<div>
										<div
											@click="showfiltercard = !showfiltercard"
											class="xMarkCancel pointer"
										>
											<img src="../../assets/xmark.svg" alt="" />
										</div>
										<div>
											<div class="topDiv mt-3">
												<label class="fieldsetStyle">Sections </label>
												<b-form-input
													class="filterinputField"
													id="input-1"
													type="number"
													@keypress="avoidLetterE"
													min="0"
													max="1000"
													v-model="filter.section"
													placeholder="Enter Sections"
												></b-form-input>
											</div>
										</div>

										<div class="topicfilterinnercard mt-3">
											<div class="d-flex">
												<span style="color: #545454">Public Availability </span>
												<b-form-radio-group
													class="ml-3"
													:options="options"
													v-model="filter.publicAvailability"
													value-field="item"
													text-field="name"
													disabled-field="notEnabled"
													size="sm"
												></b-form-radio-group>
											</div>
										</div>
										<div class="d-flex justify-content-between mt-3">
											<div
												class="clearfilter pointer mt-3"
												:class="
													clearFilterclass
														? filtercount == 0
															? 'disabled-text'
															: 'pointer'
														: 'pointer'
												"
												@click="
													clearFilterclass
														? filtercount == 0
															? clearfilterbox()
															: clearfilter()
														: filtercount == 0
														? clearfilterbox()
														: clearfilter()
												"
											>
												Clear Filter
											</div>
											<div>
												<b-button
													class="addbtn"
													:disabled="clearFilterclass"
													@click="applyfilter()"
												>
													Apply
												</b-button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="d-flex switchParent ml-2">
						<div
							v-b-popover.hover.top="'Grid View'"
							class="switchChild"
							@click="LoaderStatus == true ? '' : saveToggleView()"
							:class="{
								activeSwitchLeft: !switchviews,
								notActiveSwitchLeft: switchviews,
							}"
						>
							<img src="../../assets/filtersorticon.svg" alt="" />
						</div>
						<div
							v-b-popover.hover.top="'List View'"
							class="switchChild"
							@click="
								LoaderStatus == true ? '' : (topicState = []), saveToggleView()
							"
							:class="{
								activeSwitchRight: switchviews,
								notActiveSwitchRight: !switchviews,
							}"
						>
							<img src="../../assets/rightfilterwhite.svg" alt="" />
						</div>
					</div>
				</div>
			</div>
			<div class="d-flex mt-3">
				<div
					:class="{
						'archivetest-left-container-preview': showTestPreview,

						'archivetest-left-container': !showTestPreview,
						'archivetest-left-container width100':
							!roles.includes('GET_SECTION') || !roles.includes('GET_QUESTION'),
					}"
				>
					<div class="position-relative">
						<div class="archivetest-cards-container">
							<div
								v-if="tests.length == 0 && !LoaderStatus"
								class="d-flex flex-column align-items-center justify-content-center h-100"
							>
								<div
									class="add-access-user-head d-flex align-items-center justify-content-center m-2 text-break p-2 flex-column"
								>
									<div>
										<img src="../../assets/searchnotfound.svg" alt="" />
									</div>
									<div v-if="searchTopicTest != ''">
										No matching results for "{{ searchTopicTest }}"
									</div>
									<div v-else>
										<span class="searchnotfound">No data found.</span>
									</div>
								</div>
							</div>
							<div
								class="archi-test-cont"
								:class="{
									' d-flex flex-wrap': !switchviews,
								}"
							>
								<div
									v-for="(test, index) in tests"
									:key="index"
									class="tp-padng"
								>
									<template v-if="switchviews == false">
										<Archivecard
											:test="test"
											v-on:toggleview="toggleview"
											v-on:toggleTestPreview="toggleTestPreview"
											v-on:archivetestmodal="archivetestmodalClear"
										/>
									</template>
									<template v-else>
										<Archivelist
											:test="test"
											v-on:toggleview="toggleview"
											v-on:toggleTestPreview="toggleTestPreview"
											v-on:archivetestmodal="archivetestmodalClear"
										/>
									</template>
								</div>
							</div>
						</div>

						<div
							class="archivetest-paginaTion d-flex justify-content-between align-items-center"
						>
							<div style="width: 37%" class="d-flex">
								<span class="qb-gotopage-text p-1">Go to page</span>
								<b-form-input
									type="text"
									class="qb-pagination-num mr-1"
									v-model="goToPage"
									@keyup.enter="
										goToPage == null || goToPage == '' || iscontainsNumberTest
											? ''
											: goToPageNo(goToPage)
									"
								></b-form-input>
								<b-button
									class="qb-pagination-addbtn"
									@click="goToPageNo(goToPage)"
									:disabled="
										goToPage === null || goToPage == '' || iscontainsNumberTest
									"
								>
									<span
										><img src="../../assets/whiterightarrow.svg" alt=""
									/></span>
								</b-button>
							</div>
							<div
								style="width: 38%"
								class="pagination d-flex justify-content-center"
							>
								<b-pagination
									v-model.number="currentPage"
									@input="getArchivedTest()"
									:total-rows="total"
									:per-page="count"
									align="center"
									first-number
									last-number
								>
									<template #prev-text
										><span
											><img src="../../assets/leftvector.svg" alt="" /> </span
									></template>
									<template #next-text
										><span><img src="../../assets/rightarrow.svg" alt=""/></span
									></template>
								</b-pagination>
							</div>
							<div
								style="width: 25%"
								class="qb-gotopage-text d-flex justify-content-end"
							>
								Results : <span class="ml-1">{{ pageStart }}</span>
								<span class="ml-1 mr-1">-</span>
								{{ pageEnd }} of
								{{ total }}
								<!-- {{Math.ceil(allQuestions.total / this.question_count)}} -->
							</div>
						</div>
					</div>
				</div>
				<div
					v-if="roles.includes('GET_QUESTION') && roles.includes('GET_SECTION')"
					class="ml-2 relativeclass"
					:class="
						showTestPreview
							? 'archivetest-right-container-preview'
							: 'archivetest-right-container'
					"
				>
					<div
						class="d-flex flex-column align-items-center justify-content-center h-100"
						v-if="!showTestPreview"
					>
						<div>
							<img src="../../assets/icons/Archivetest/emptytest.svg" alt="" />
						</div>
						<div class="empty-archivetest-txt mt-2">
							Click on <b>"Eye"</b> icon to Preview Test Details
						</div>
					</div>
					<template v-else>
						<TestPreview
							:type="'archivePreview'"
							v-on:toggleTestPreview="toggleTestPreview"
							v-on:toggleview="toggleview"
						/>
					</template>
				</div>
			</div>
		</div>
		<b-modal
			id="archivetestmodal"
			centered
			hide-footer
			hide-header
			size="lg"
			no-close-on-backdrop
		>
			<div
				class="modalheading d-flex align-items-center justify-content-between modal-text"
			>
				Tag Tests
			</div>
			<div
				@click="toggleview('clone', null), $bvModal.hide('archivetestmodal')"
				class="xMarkCancel"
			>
				<img src="../../assets/xmark.svg" alt="" />
			</div>

			<hr />
			<div class="mt-3 position-relative">
				<b-overlay :show="showSpinner" rounded="sm">
					<div class="tagtest-head">
						Please select the topics you would like to add this test.
					</div>
					<div class="d-flex align-items-center mt-3">
						<div style="width: 85%" class="position-relative search-bar">
							<span class="search-pos">
								<img src="../../assets/searchicon.svg" alt=""
							/></span>
							<b-form-input
								class="search-input"
								type="search"
								placeholder="Search here"
								@keyup="searchTopics"
								@input="searchTopics"
								v-model="search"
							></b-form-input>
						</div>
						<div style="width: 15%" class="ml-2">
							<b-button
								class="addbtn pl-3 pr-3"
								@click="tagTest(), (showSpinner = true)"
								:disabled="selectedTopics.length == 0"
							>
								Tag Test
							</b-button>
						</div>
					</div>

					<div class="">
						<div class="d-flex" style="justify-content: space-between">
							<div class="archivetestcheckbox mt-3">
								<b-form-checkbox
									v-model="selectall"
									@change="selectAll()"
									v-if="topics.length > 0"
								>
									Select all topics
								</b-form-checkbox>
							</div>
							<div
								v-if="selectedTopics.length != 0"
								class="archivelist-topictxt mt-3 mr-3"
							>
								Topics selected : {{ selectedTopics.length }}
							</div>
						</div>
						<div style="height: calc(100vh - 360px); overflow-y: auto">
							<div
								style="margin-top: 170px"
								v-if="showLoader"
								class="d-flex justify-content-center mb-3"
							>
								<b-spinner label="Loading..."></b-spinner>
							</div>

							<div v-else>
								<div
									class="archivetest-list-cards add-access-user-head d-flex align-items-center justify-content-center m-2 text-break p-2"
									style="height: 90%"
									v-if="topics.length == 0 && search != ''"
								>
									No matching results for "{{ search }}"
								</div>

								<div
									class="archivetest-list-cards d-flex m-2 align-items-center"
									style="height: 60px"
									v-for="(topic, index) in topics"
									:key="index"
								>
									<div
										class="archivetestcheckbox d-flex pt-1 pl-2 align-items-baseline"
										style="width: 5%"
									>
										<b-form-checkbox
											class="mr-1"
											v-model="selectedTopics"
											:value="topic.topicID"
											@change="deselect()"
										>
										</b-form-checkbox>
									</div>
									<div style="width: 95%" class="d-flex align-items-center">
										<div style="width: 65%">
											<div class="archivelist-topictxt text-truncate">
												Topic Name :
												<span v-b-popover.hover.top="topic.name">
													{{ topic.name }}
												</span>
											</div>
										</div>
										<div style="width: 15%">
											<div class="d-flex align-items-center">
												<span class="archivesections-txt">Tests</span>
												<span class="archivegreennumbertext ml-2">{{
													topic.testCount
												}}</span>
											</div>
										</div>
										<div style="width: 15%" class="ml-3">
											<div class="d-flex align-items-center">
												<span class="archivesections-txt">Candidates</span>

												<span class="archivebluenumbertext ml-2">{{
													topic.candidateCount
												}}</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div
						class="archivetest-paginaTion d-flex justify-content-between align-items-center"
					>
						<div style="width: 37%" class="d-flex">
							<span class="qb-gotopage-text p-1">Go to page</span>
							<b-form-input
								type="text"
								class="qb-pagination-num mr-1"
								v-model="goToTopicPage"
								@keyup.enter="
									goToTopicPage === null ||
									goToTopicPage == '' ||
									iscontainsNumber
										? ''
										: goToTopicPageNo(goToTopicPage)
								"
							></b-form-input>
							<b-button
								class="qb-pagination-addbtn"
								@click="goToTopicPageNo(goToTopicPage)"
								:disabled="
									goToTopicPage === null ||
										goToTopicPage == '' ||
										iscontainsNumber
								"
							>
								<span
									><img src="../../assets/whiterightarrow.svg" alt=""
								/></span>
							</b-button>
						</div>
						<div
							style="width: 38%"
							class="pagination d-flex justify-content-center"
						>
							<b-pagination
								v-model.number="currentTopicPage"
								@input="archivetestmodal()"
								:total-rows="totalTopic"
								:per-page="count"
								align="center"
								first-number
								last-number
							>
								<template #prev-text
									><span><img src="../../assets/leftvector.svg" alt="" /> </span
								></template>
								<template #next-text
									><span><img src="../../assets/rightarrow.svg" alt=""/></span
								></template>
							</b-pagination>
						</div>
						<div
							style="width: 25%"
							class="qb-gotopage-text d-flex justify-content-end"
						>
							Results : <span>{{ topicPageStart }}</span> -
							{{ topicPageEnd }} of
							{{ totalTopic }}
							<!-- {{Math.ceil(allQuestions.total / this.question_count)}} -->
						</div>
					</div>
				</b-overlay>
			</div>
		</b-modal>
	</div>
</template>

<script>
import Archivecard from "./Archivecardview.vue";
import Archivelist from "./Archivelistview.vue";
import {
	getArchivedTest,
	getDataBasedOnLazyLoadingInHomePage,
	postArchivedTest,
} from "../../utils/apiFunctions";
import { mapMutations, mapGetters } from "vuex";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import TestPreview from "../../views/test/TestPreview.vue";
import successToast from "../mixin/toast.js";
import errorToast from "../mixin/toast";
export default {
	data() {
		return {
			showLoader: false,
			showSpinner: false,
			property: "value",
			tests: [],
			showTestPreview: false,
			selectedtest: null,
			search: "",
			topics: [],
			selectedTopics: [],
			selectedTests: [],
			goToTopicPage: null,
			totalTopic: null,
			topicPageStart: null,
			topicPageEnd: null,
			selectall: false,
			showfiltercard: false,
			count: 50,
			LoaderStatus: false,
			currentTopicPage: 1,
			currentPage: 1,
			goToPage: null,
			total: null,
			pageStart: null,
			pageEnd: null,
			filtercount: 0,
			showSortCard: false,
			sort_selected: {
				column: "createdAt",
				order: "-1",
			},
			filter: {
				publicAvailability: null,
				section: "",
			},
			storefilterdata: {
				publicAvailability: null,
				section: "",
			},
			options: [
				{
					item: true,
					name: "Yes",
				},
				{
					item: false,
					name: "No",
				},
			],
			sort_options: [
				{ text: "Test(Asc)", value: "1", type: "testName", order: "1" },
				{ text: "Test(Desc)", value: "2", type: "testName", order: "-1" },
				{
					text: "Date Created(Asc)",
					value: "3",
					type: "createdAt",
					order: "1",
				},
				{
					text: "Date Created(Desc) (Default)",
					value: "4",
					type: "createdAt",
					order: "-1",
				},
				{
					text: "Date Modified(Asc)",
					value: "5",
					type: "updatedAt",
					order: "1",
				},
				{
					text: "Date Modified(Desc)",
					value: "6",
					type: "updatedAt",
					order: "-1",
				},
			],
		};
	},
	mixins: [successToast, errorToast],

	components: {
		Spinner,
		Archivecard,
		Archivelist,
		TestPreview,
	},
	computed: {
		...mapGetters(["roles"]),
		...mapGetters("searchVUEX", {
			list: "getListView",
			grid: "getGridView",
			switchviews: "getToggleView",
			searchTopicTest: "getSearchTopicTest",
		}),
		iscontainsNumber() {
			return !/^[1-9]\d*$/.test(this.goToTopicPage);
		},
		iscontainsNumberTest() {
			return !/^[1-9]\d*$/.test(this.goToPage);
		},
		clearFilterclass() {
			return (
				this.filter.publicAvailability == null &&
				this.filter.section.toString().length == 0
			);
		},
	},
	watch: {
		searchTopicTest(newValue, oldValue) {
			let timer = 200;
			setTimeout(() => {
				if (newValue != oldValue) {
					this.getArchivedTest();
				}
			}, timer);
		},
		sort_selected() {
			this.$router.push({
				path: "/archivetest",
				query: {
					type: this.$route.query.type,
					sort: this.$route.query.sort,
					column: this.sort_selected.column,
					order: this.sort_selected.order,
				},
			});
		},
	},
	created() {
		// this.getArchivedTest();
		// Managing tab redirect based on Sort
		this.tabRedirect();
	},
	methods: {
		...mapMutations("searchVUEX", {
			saveToggleView: "saveToggleView",
		}),
		hidesortoptions() {
			this.showSortCard = false;
		},
		hidefilteroptions() {
			this.showfiltercard = false;
		},
		openFilter() {
			this.showfiltercard = !this.showfiltercard;
			this.filter = { ...this.storefilterdata };
		},
		// Managing tab redirect based on Sort
		tabRedirect() {
			if (this.$route.query.column || this.$route.query.order) {
				this.sort_selected.column = this.$route.query.column;
				this.sort_selected.order = this.$route.query.order;
				this.getArchivedTest();
				return;
			}
			this.getArchivedTest();
		},
		avoidLetterE(event) {
			const key = event.key;
			const maxLength = 3;
			const hasDecimal = this.filter.section.includes(".");
			const numbersRegex = /^\d+$/;
			if (
				key.toLowerCase() === "e" ||
				hasDecimal ||
				key === "." ||
				this.filter.section.length >= maxLength ||
				!numbersRegex.test(key)
			) {
				event.preventDefault();
			}
		},
		...mapMutations("searchVUEX", {
			saveToggleView: "saveToggleView",
		}),
		goTobackpage() {
			this.$router.push({
				name: "Home",
				query: {
					type: this.$route.query.type,
					sort: this.$route.query.sort,
				},
			});
		},
		archivetestmodalClear(data) {
			this.search = "";
			this.selectedTests = [];
			this.selectedTopics = [];
			this.selectall = false;
			this.archivetestmodal(data);
		},
		async getArchivedTest() {
			this.LoaderStatus = true;
			this.showTestPreview = false;
			try {
				let payload = {
					type: 0,
					searchQuery: this.searchTopicTest,
					sortBy: {
						column: this.sort_selected.column,
						order: this.sort_selected.order,
					},
					page: this.currentPage - 1,
					count: this.count,
					filters: {
						numberOfSections:
							this.filter.section == ""
								? this.filter.section
								: parseInt(this.filter.section, 10),
						publicAvailability: this.filter.publicAvailability,
					},
				};
				if (
					(payload.filters.numberOfSections == "" ||
						payload.filters.numberOfSections == null) &&
					parseInt(payload.filters.numberOfSections, 10) != 0
				) {
					delete payload.filters.numberOfSections;
				}
				if (payload.filters.publicAvailability == null) {
					delete payload.filters.publicAvailability;
				}
				const res = await getArchivedTest(payload);
				if (res.status == 200) {
					this.tests = res.data.data.data;
					this.total = res.data.data.total;
					this.pageEnd = res.data.data.pageEnd;
					this.pageStart = res.data.data.pageStart;
					this.tests = this.tests.map((data) => {
						return { ...data, view: false, clone: false };
					});
					this.LoaderStatus = false;
				}
			} catch (error) {
				console.log(error);
			}
		},
		applyfilter() {
			this.storefilterdata = { ...this.filter };
			this.filtercount = 0;
			if (this.filter.section.toString().length > 0) {
				this.filtercount++;
			}
			if (this.filter.publicAvailability != null) {
				this.filtercount++;
			}
			this.getArchivedTest();
			this.showfiltercard = false;
		},
		applySort() {
			this.getArchivedTest();
			this.showSortCard = !this.showSortCard;
		},
		toggleTestPreview(data) {
			console.log("toggle gtest preview");
			this.showTestPreview = data;
			this.$forceUpdate();
		},
		toggleview(key, data) {
			for (let i in this.tests) {
				this.tests[i][key] = false;
				if (data != null) {
					if (this.tests[i].testID == data) {
						console.log(this.tests[i]);
						this.tests[i][key] = true;
					}
				}
			}
		},
		async archivetestmodal(data) {
			this.showLoader = true;
			try {
				let payload = {
					type: 1,
					searchQuery: this.search,
					topicID: "",
					sortBy: "createdAt",
					order: -1,
					count: this.count,
					page: this.currentTopicPage - 1,
				};
				const res = await getDataBasedOnLazyLoadingInHomePage(payload);
				if (res.status == 200) {
					this.topics = res.data.data.topicIDs;
					this.totalTopic = res.data.data.total;
					this.topicPageEnd = res.data.data.pageEnd;
					this.topicPageStart = res.data.data.pageStart;
					this.checkSelectAll();
					this.showLoader = false;
				}
				// to check whether the data coming as an argument have testID as key since we are calling this method in multiple places
				if (data["testID"] != undefined) {
					this.selectedTests.push(data);
				}
			} catch (error) {
				console.log(error);
			}
			this.$bvModal.show("archivetestmodal");
		},
		goToTopicPageNo(index) {
			this.currentTopicPage = Math.min(
				index,
				Math.ceil(this.totalTopic / this.count)
			);
			this.goToTopicPage = null;
			this.archivetestmodal();
		},
		goToPageNo(index) {
			this.currentPage = Math.min(index, Math.ceil(this.total / this.count));
			this.goToPage = null;
			this.getArchivedTest();
		},
		selectAll() {
			if (this.selectall) {
				for (let i in this.topics) {
					if (
						this.selectedTopics.filter(
							(value) => value == this.topics[i].topicID
						).length === 0
					) {
						this.selectedTopics.push(this.topics[i].topicID);
					}
				}
			} else {
				for (let j in this.topics) {
					if (
						this.selectedTopics.filter(
							(value) => value == this.topics[j].topicID
						).length > 0
					) {
						this.selectedTopics.splice(
							this.selectedTopics.indexOf(this.topics[j].topicID),
							1
						);
					}
				}
			}
		},

		deselect() {
			this.selectall = false;

			const containsAll = this.topics.every((element) => {
				return this.selectedTopics.includes(element.topicID);
			});
			if (containsAll) {
				this.selectall = true;
			}
		},
		checkSelectAll() {
			let isSelectedAll = true;
			if (this.topics.length == 0) {
				isSelectedAll = false;
			} else {
				for (let i of this.topics) {
					let record = i;
					if (
						this.selectedTopics.filter((value) => value == record.topicID)
							.length === 0
					) {
						isSelectedAll = false;
					}
				}
			}

			this.selectall = isSelectedAll;
		},
		async tagTest() {
			try {
				let payload = {
					topicIDs: this.selectedTopics,
					testIDs: this.selectedTests,
					failCheck: false,
				};
				const res = await postArchivedTest(payload);
				if (res.status == 200) {
					this.selectedTopics = [];
					this.selectedTests = [];
					this.$bvModal.hide("archivetestmodal");
					this.toggleview("clone", null);
					this.successToast("Test tagged to selected topics successfully");
				} else {
					this.errorToast(res.data.data.Detail);
				}
			} catch (error) {
				this.errorToast("Something went wrong");

				console.log(error);
			}
			this.showSpinner = false;
		},
		clearfilterbox() {
			this.filter = {
				publicAvailability: null,
				section: "",
			};
			this.filtercount = 0;
			this.showfiltercard = true;
		},
		clearfilter() {
			this.filter = {
				publicAvailability: null,
				section: "",
			};
			this.storefilterdata = {
				publicAvailability: null,
				section: "",
			};
			this.filtercount = 0;
			this.currentPage = 1;
			this.getArchivedTest();
			this.showfiltercard = false;
		},
		searchTopics() {
			clearTimeout(this.timer);
			this.timer = setTimeout(() => {
				this.archivetestmodal();
			}, 200);
		},
	},
};
</script>

<style>
.width100 {
	width: 100% !important;
}
.gridgreencolordynamic {
	width: 4px;
	height: 70px;
	border-radius: 2px;
	position: absolute;
	background: #4ef085;
	left: 2px;
	top: 5px;
}
.archivetest-list-cards {
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	height: 80px;
	position: relative;
}
.archivelist-topictxt {
	font-weight: 400;
	font-size: 13px;
	color: #696969;
}
.archivelist-testtxt {
	font-weight: 600;
	font-size: 14px;
	color: #1a4164;
}
.gap-15 {
	gap: 15px;
}
.archivetest-activeindication {
	width: 11px;
	height: 11px;
	background: #038e00;
	border-radius: 50%;
}
.archive-tst-topicbox {
	background: #f7f7f7;
	border-radius: 5px;
	padding: 5px 10px;
	height: 71px;
}
.archive-tst-innerbox {
	background: #ffffff;
	box-shadow: 0px -2px 20px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	padding: 5px 10px;
	height: 71px;
}
.archivecards-topicnametxt {
	font-weight: 300;
	font-size: 11px;
	color: #696969;
}
.archivecards-topictxt {
	font-weight: 400;
	font-size: 13px;
	color: #696969;
}
.archivetest-cards {
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	width: 302px;
	border: 2px solid white;
	height: 215px;
	padding: 15px;
}
.archivetest-left-container {
	background: #ffffff;
	box-shadow: 0px 0px 14px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	width: 75%;
}
.archivetest-left-container-preview {
	background: #ffffff;
	box-shadow: 0px 0px 14px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	width: 60%;
}
.archivetest-cards-container {
	height: calc(100vh - 180px);
}

.archi-test-cont {
	min-height: auto;
	max-height: calc(100vh - 180px);
	padding: 15px;
	overflow: auto;
}
.archivetest-right-container {
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	width: 25%;
	height: calc(100vh - 140px);
}
.archivetest-right-container-preview {
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	width: 40%;
	height: calc(100vh - 140px);
}
.archivetest-main-container {
	position: relative;
	top: 70px;
	height: calc(100vh - 90px);
	width: 100%;
	padding-left: 80px;
	padding-right: 5px;
}
.heading-container::before {
	content: "";
	display: inline-block;
	position: absolute;
	width: 25px;
	height: 21px;
	top: 2px;
	left: -11px;
	z-index: -1;
	background: var(--cv-yellow);
	-moz-border-radius: 10px;
	-webkit-border-radius: 10px;
	border-radius: 50%;
}

.heading-container {
	position: relative;
	z-index: 1;
	font-weight: 600;
	font-size: 18px;
	color: #72738e;
}
.sort-box {
	border: 1px solid #72738e;
	padding-top: 5px;
	border-radius: 3px;
}

.filter-box {
	border: 1px solid #72738e;
	padding: 5px;
	border-radius: 3px;
}
.empty-archivetest-txt {
	font-weight: 400;
	font-size: 12px;
	color: #696969;
}
.archivetest-filter-count {
	width: 19px;
	background: #ff7e47;
	border-radius: 10px;
	height: 19px;
	font-weight: var(--weight-B);
	font-size: var(--size-10);
	padding-top: 2px;
	padding-left: 8px;
	position: absolute;
	top: -5px;
	right: -15px;
}
.archivetest-paginaTion {
	width: 100%;
	padding: 5px 10px;
	box-shadow: 0px 0px 5px rgb(0 0 0 / 15%);
	border-radius: 0px 0px 5px 5px;
	background: #f2f4fd;
	z-index: 1;
}

/* sort card design */
.tnt-sortcard .custom-control {
	padding-left: 2rem !important;
	padding-top: 5px;
	padding-bottom: 5px;
}

.sort-radio:nth-child(even) {
	background: #fdfdfd;
}

.sort-radio:nth-child(odd) {
	background: #f4f4f4;
}

.archivedTest-typecard {
	width: 245px;
}

.boxtext {
	font-weight: var(--weight-M);
	font-size: var(--size-18);

	color: var(--headtext) !important;
}
</style>
